export const lcMastheadStandard = {
  heading: 'Human Interest Learning Center',
  headingHighlight: 'Human Interest',
  paragraph: {
    json: {
      data: {},
      content: [
        {
          data: {},
          content: [
            {
              data: {},
              marks: [],
              value:
                'We’re here to help make it easier to navigate the world of investing, retirement, and 401(k)s.',
              nodeType: 'text',
            },
          ],
          nodeType: 'paragraph',
        },
      ],
      nodeType: 'document',
    },
  },
  searchInput: 'Search Learning Center',
  background: 'teal10',
  imagesCollection: {
    items: [
      {
        sys: {
          id: '2nkWKo7UYQ16mY5cSJpEbQ',
        },
        altText: 'Screenshot of participant contribution adjustment feature',
        width: 380,
        height: 300,
        image: {
          title: 'change-contributions-screenshot',
          url: 'https://images.ctfassets.net/tj9jxg7kaxby/Jm3pzTRKBeBBpG0PLSv8g/5a5108f296115bc9b49de0c523c887ed/Humanify_LP_UI_Kit__1_..png',
          description: '',
        },
      },
      {
        sys: {
          id: '5cvuCp0Lksw54XwWVD3TVb',
        },
        altText: 'Screenshot of investment portfolio feature',
        width: 380,
        height: 300,
        image: {
          title: 'update-portfolio-screenshot',
          url: 'https://images.ctfassets.net/tj9jxg7kaxby/4HCzjRAxo7Mk6KaBWtYBZF/e226b33b601c9dee196444edfe2bf254/LC_homepage_illustration.png',
          description: '',
        },
      },
    ],
  },
};
